module.exports = __webpack_public_path__ + "img/vip_pc_tab_01.6f40d6f6.png";